import gql from 'graphql-tag';

const specialistServiceList = gql`
    query GetSpecialistServiceList {
        specialistService {
            displayText
            path
            subtitle
            bannerImage {
                urls
            }
            externalURL {
                url
                text
            }
            whiteTitle
        }
    }
`;

const specialistServiceDetail = gql`
    query GetSpecialistServiceDetail($path: String!) {
        specialistService(where: { path: $path }) {
            displayText
            path
            subtitle
            bannerImage {
                urls
            }
            divisionLogo {
                urls
            }
            externalURL {
                url
                text
            }
            whiteTitle
            serviceOfferings {
                contentItems {
                    ... on ServiceOffering {
                        displayText
                        markdownBody {
                            html
                        }
                    }
                }
            }
            specialistServiceContent {
                contentItems {
                    ... on ContentBlockFlowpart {
                        displayText
                        image {
                            urls
                        }
                        imagePosition
                        markdownBody {
                            html
                        }
                        contentBlockSubtitle
                    }
                    ... on Accordion {
                        displayText
                        subtitle
                        accordionContent {
                            contentItems {
                                ... on AccordionItem {
                                    displayText
                                    markdownBody {
                                        html
                                    }
                                }
                            }
                        }
                    }
                    ... on Buttons {
                        buttonList {
                            contentItems {
                                displayText
                                ... on LinkMenuItem {
                                    linkMenuItem {
                                        url
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export {
    specialistServiceList,
    specialistServiceDetail
};